import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function EmailFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Automate your email outreach with personal email sequences'
            subHeader='Automatically send tailored emails as leads progress through your sales pipeline.'
            bullets={[
                'Write a sequence of messages which will automatically be sent by Nutshell, as if you sent them personally.',
                'Send personalized emails automatically as leads progress through your sales pipeline.',
                'Save time on manual follow-ups and focus on nurturing valuable relationships.',
                'Track email performance and gain insights to refine your outreach strategy.',
            ]}
            feature='automatedEmails'
        />
    );
}
